var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _rect11, _rect12, _rect13, _path3, _rect14, _rect15, _rect16, _path4, _rect17, _rect18, _rect19, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgUnderMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.6001,
    y: 57.6,
    width: 172.8,
    height: 124.8,
    rx: 6.4,
    fill: "#ECECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6001 64C33.6001 60.4654 36.4655 57.6 40.0001 57.6H200C203.535 57.6 206.4 60.4654 206.4 64V69.4857H33.6001V64Z",
    fill: "#CFCFD3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3032,
    y: 61.3143,
    width: 4.46897,
    height: 4.45714,
    rx: 2.22857,
    fill: "#9D9DA1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.752,
    y: 61.3143,
    width: 4.46897,
    height: 4.45714,
    rx: 2.22857,
    fill: "#9D9DA1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.2002,
    y: 61.3143,
    width: 4.46897,
    height: 4.45714,
    rx: 2.22857,
    fill: "#9D9DA1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 152,
    width: 44,
    height: 20,
    rx: 3.2,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 152,
    width: 44,
    height: 20,
    rx: 3.2,
    stroke: "#9D9DA1",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeDasharray: "1.6 3.2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 152,
    width: 44,
    height: 20,
    rx: 3.2,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91.2002,
    y: 83.2,
    width: 102.4,
    height: 57.6,
    rx: 3.2,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3999,
    y: 104,
    width: 57.6,
    height: 6.4,
    rx: 3.2,
    fill: "#9D9DA1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3999,
    y: 113.6,
    width: 38.4,
    height: 6.4,
    rx: 3.2,
    fill: "#9D9DA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9566 81.1619C27.5139 80.5414 28.4864 80.5414 29.0437 81.1619L42.9044 96.5953C43.7153 97.4982 43.0745 98.9351 41.8608 98.9351H14.1394C12.9258 98.9351 12.285 97.4982 13.0959 96.5953L26.9566 81.1619Z",
    fill: "#00DBBF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8184,
    y: 97.1818,
    width: 16.3636,
    height: 9,
    rx: 1.4026,
    fill: "#00DBBF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8184,
    y: 107.818,
    width: 16.3636,
    height: 3.27273,
    rx: 1.4026,
    fill: "#00DBBF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8184,
    y: 112.727,
    width: 16.3636,
    height: 3.27273,
    rx: 1.4026,
    fill: "#00DBBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.235 130.652C222.643 130.197 223.356 130.197 223.765 130.652L233.93 141.97C234.524 142.632 234.054 143.686 233.164 143.686H212.835C211.945 143.686 211.475 142.632 212.07 141.97L222.235 130.652Z",
    fill: "#00DBBF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 142.4,
    width: 12.0001,
    height: 6.6,
    rx: 1.02858,
    fill: "#00DBBF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 150.2,
    width: 12.0001,
    height: 2.4,
    rx: 1.02858,
    fill: "#00DBBF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 153.8,
    width: 12.0001,
    height: 2.4,
    rx: 1.02858,
    fill: "#00DBBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.725 149.42C199.406 148.662 200.594 148.662 201.275 149.42L218.216 168.283C219.207 169.387 218.424 171.143 216.941 171.143H183.059C181.576 171.143 180.793 169.387 181.784 168.283L198.725 149.42Z",
    fill: "#00DBBF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 169,
    width: 20,
    height: 11,
    rx: 1.71429,
    fill: "#00DBBF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 182,
    width: 20,
    height: 4,
    rx: 1.71429,
    fill: "#00DBBF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 188,
    width: 20,
    height: 4,
    rx: 1.71429,
    fill: "#00DBBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.387 194.335C218.323 193.888 217.677 193.888 217.613 194.335C216.926 199.146 213.146 202.926 208.335 203.613C207.888 203.677 207.888 204.323 208.335 204.387C213.146 205.074 216.926 208.854 217.613 213.665C217.677 214.112 218.323 214.112 218.387 213.665C219.074 208.854 222.854 205.074 227.665 204.387C228.112 204.323 228.112 203.677 227.665 203.613C222.854 202.926 219.074 199.146 218.387 194.335Z",
    fill: "#FDD835"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.271 184.235C231.226 183.922 230.774 183.922 230.729 184.235C230.248 187.602 227.602 190.248 224.235 190.729C223.922 190.774 223.922 191.226 224.235 191.271C227.602 191.752 230.248 194.398 230.729 197.765C230.774 198.078 231.226 198.078 231.271 197.765C231.752 194.398 234.398 191.752 237.765 191.271C238.078 191.226 238.078 190.774 237.765 190.729C234.398 190.248 231.752 187.602 231.271 184.235Z",
    fill: "#FDD835"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.232 53.2012C16.1936 52.9329 15.8064 52.9329 15.768 53.2012C15.3557 56.0877 13.0877 58.3557 10.2012 58.768C9.93294 58.8064 9.93294 59.1936 10.2012 59.232C13.0877 59.6443 15.3557 61.9123 15.768 64.7988C15.8064 65.0671 16.1936 65.0671 16.232 64.7988C16.6443 61.9123 18.9123 59.6443 21.7988 59.232C22.0671 59.1936 22.0671 58.8064 21.7988 58.768C18.9123 58.3557 16.6443 56.0877 16.232 53.2012Z",
    fill: "#FDD835"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8479 36.3018C27.7905 35.8994 27.2095 35.8994 27.1521 36.3018C26.5335 40.6316 23.1316 44.0335 18.8018 44.6521C18.3994 44.7095 18.3994 45.2905 18.8018 45.3479C23.1316 45.9665 26.5335 49.3684 27.1521 53.6982C27.2095 54.1006 27.7905 54.1006 27.8479 53.6982C28.4665 49.3684 31.8684 45.9665 36.1982 45.3479C36.6006 45.2905 36.6006 44.7095 36.1982 44.6521C31.8684 44.0335 28.4665 40.6316 27.8479 36.3018Z",
    fill: "#FDD835"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUnderMaintenance);
export default __webpack_public_path__ + "static/media/img-under-maintenance.b994cce3d1b49162dbb97af1b0531bcb.svg";
export { ForwardRef as ReactComponent };